import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';


@Component({
  selector: 'app-receivables',
  templateUrl: './receivables.component.html',
  styleUrls: ['./receivables.component.css']
})
export class ReceivablesComponent implements OnInit {

@ViewChild(DataTableDirective, { static: false })
dtElement: DataTableDirective;

dtOptions: DataTables.Settings = {};
dtTrigger: Subject<any> = new Subject();

  constructor( private http: HttpClient) { }
//  selectedPaymentType: string = '';
selectedPaymentType: string = 'credit'; // Set default to 'credit'

  filterIsMonthRange = false;
  filterDateSelection = '';
 filterAdvisors: any[] = [];
 paymentMethodValue: any = '';
  customerTypeValue: any = '';
  brokerTypeValue: any = '';
  invoiceTypeValue: any = ''
  specialInvoiceTypeValue: any = ''
  customerid: any = '';
  filterReportType = '';
fusbillCustomerId: any = '';
viewInVoices = false;
  invoiceAmountDetails: any;
 

  // https://commonloginapiurl/app/server/MemberInvoices/47489-25-07-00.pdf
// CR_DOMAIN = environment.commonLoginApiUrl; 
// INVOICE_PREFIX_PATH = 'app/server/MemberInvoices/';
// INVOICE_SUFFIX_PATH = '.pdf';

// openInvoice(invoiceNumber: string) {
//   const invoiceLink = `https://${this.CR_DOMAIN}/${this.INVOICE_PREFIX_PATH}${invoiceNumber}${this.INVOICE_SUFFIX_PATH}`;
//   console.log('Generated Invoice Link:', invoiceLink);
//   window.open(invoiceLink, '_blank');
// }
CR_DOMAIN = environment.commonLoginApiUrl; 
INVOICE_PREFIX_PATH = 'app/server/MemberInvoices/';
INVOICE_SUFFIX_PATH = '.pdf';

openInvoice(invoiceNumber: string) {
  // Ensure no double slashes when concatenating
  const domain = this.CR_DOMAIN.replace(/\/+$/, ''); // remove trailing slash
  const prefix = this.INVOICE_PREFIX_PATH.replace(/^\/+/, ''); // remove leading slash
  const invoiceLink = `${domain}/${prefix}${invoiceNumber}${this.INVOICE_SUFFIX_PATH}`;
  
  console.log('Generated Invoice Link:', invoiceLink);
  window.open(invoiceLink, '_blank');
}



rerenderDataTable(): void {
  if (this.dtElement && this.dtElement.dtInstance) {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy(); // destroy existing table
this.dtTrigger.next(null);
    });
  }
}



downloadArrears(): void {
  // Export only the visible `pagedData`, or use `filteredData` if needed
  const exportData = this.filteredData.map(item => ({
    'IGBMS ID': item.customerId,
    'Auth ID': item.authorizenetCustomerId,
    'Stax ID': item.fusebillCustomerId,
    'Member Name': `${item.firstName ?? ''} ${item.lastName ?? ''}`,
    'Company': item.companyName,
    'Amount': item.amount,
    'Invoice No': item.invoiceNumber,
    'Due Date': item.dueDate ? new Date(item.dueDate).toLocaleDateString() : '',
    'Payment Platform': item.paymentPlatform,
    'Status': item.paymentStatus,
  }));

  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
  const workbook: XLSX.WorkBook = {
    Sheets: { 'Receivables': worksheet },
    SheetNames: ['Receivables']
  };

  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob: Blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  FileSaver.saveAs(blob, `receivables_${new Date().toISOString().split('T')[0]}.xlsx`);
}



onStatusChange(event: Event): void {
  const checkbox = event.target as HTMLInputElement;
  const value = checkbox.value;

  if (checkbox.checked) {
    this.selectedStatuses.push(value);
  } else {
    this.selectedStatuses = this.selectedStatuses.filter(status => status !== value);
  }
  this.applyFilters(); 
}



creditCardData = [];
eftData = [];
padData = [];


 onRangeChange() {

    this.filterDateSelection = '';
    this.filterAdvisors = [];
    this.paymentMethodValue = ''
    this.customerTypeValue = ''
    this.brokerTypeValue = ''
    this.invoiceTypeValue = ''
    this.filterReportType = ''
    this.customerid = ''
    this.fusbillCustomerId = ''
    // this.BrokersData = []
    this.viewInVoices = false;

    this.invoiceAmountDetails = false
    // $('#DataTables_Table_1').dataTable().fnDestroy();
    // this.dtTrigger.next(null);
  }

selectPaymentType(type: string) {
  this.selectedPaymentType = type;

  this.applyFilters();
}

// Number of rows per page
pageSize: number = 10;
currentPage: number = 1;

statusOptions: string[] = [];            // populated dynamically
selectedStatuses: string[] = [];

baseStatuses: string[] = ['pending', 'success', 'failed', 'cancelled'];




getReceivables() {
  const accessToken = sessionStorage.getItem('accessToken');
  // const url = `${environment.apiUrl}/api/ap/admin-receivables`;
  const url = `${'http://[::1]:3002'}/api/ap/admin-receivables`;

  this.http.get(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }).subscribe((response: any) => {
    const data = response.data || response;

    // Filter data based on payment methods
    this.creditCardData = data.filter((x: any) => x.paymentMethod === 'CREDIT_CARD');
    this.eftData = data.filter((x: any) =>
      (x.paymentMethod !== 'ACH' && x.paymentMethod !== 'PAD') && x.paymentMethod !== 'CREDIT_CARD'
    );
    this.padData = data.filter((x: any) => x.paymentMethod === 'ACH' || x.paymentMethod === 'PAD');

    const baseStatuses = ['pending', 'success', 'failed', 'cancelled'];

    const dynamicStatuses = new Set<string>();
    data.forEach((item: any) => {
      const status = item?.specificStatus;
      if (status && typeof status === 'string' && status.trim()) {
        dynamicStatuses.add(status.trim().toLowerCase()); // normalize to lowercase
      }
    });

   
    const allStatuses = new Set([...baseStatuses, ...Array.from(dynamicStatuses)]);
    this.statusOptions = Array.from(allStatuses).sort(); // Optional: sort alphabetically

    this.applyFilters();
    this.rerenderDataTable();
    this.filteredData = this.getData(); // Optional if needed immediately
    setTimeout(() => {
      this.dtTrigger.next(null);
    }, 1000);
  });
}



// Return currently selected table data
getData(): any[] {
  switch (this.selectedPaymentType) {
    case 'credit':
      return this.creditCardData;
    case 'eft':
      return this.eftData;
    case 'pad':
      return this.padData;
    default:
      return [];
  }
}

// Slice data for current page only
searchText: string = '';

filterOptions: string[] = ['Month', 'Auth Id', 'Stax Id', 'Status'];
selectedFilters: string[] = [];

// Additional options for "Month"
statusSubFilters: string[] = ['Paid', 'Auth Fail', 'Payment Failed', 'Retry Fail'];
selectedStatusFilters: string[] = [];

onFilterChange(event: Event): void {
  const checkbox = event.target as HTMLInputElement;
  const value = checkbox.value;

  if (checkbox.checked) {
    this.selectedFilters.push(value);
  } else {
    this.selectedFilters = this.selectedFilters.filter(opt => opt !== value);

    // If "Month" was unchecked, clear its sub-filter selections
    if (value === 'Status') {
      this.selectedStatusFilters = [];
    }
  }
}

onStatusSubFilterChange(event: Event): void {
  const checkbox = event.target as HTMLInputElement;
  const value = checkbox.value;

  if (checkbox.checked) {
    this.selectedStatusFilters.push(value);
  } else {
    this.selectedStatusFilters = this.selectedStatusFilters.filter(opt => opt !== value);
  }
}

filterAuthId: any = '';
filterIgbmsId: any = '';
filterStatus: any = '';


applyFilters(): void {
  let data = [];

  switch (this.selectedPaymentType) {
    case 'credit':
      data = this.creditCardData;
      break;
    case 'pad':
      data = this.padData;
      break;
    case 'eft':
      data = this.eftData;
      break;
    default:
      data = [];
  }

  this.filteredData = data ?.filter(item => {
const matchesIgbmsId = this.filterIgbmsId
  ? item.customerId && item.customerId.toString().toLowerCase().includes(this.filterIgbmsId.toLowerCase())
  : true;


   const matchesAuthId = this.filterAuthId
  ? item.authorizenetCustomerId && item.authorizenetCustomerId.toString().toLowerCase().includes(this.filterAuthId.toLowerCase())
  : true;

 const matchesStatus = this.selectedStatuses.length
  ? this.selectedStatuses.includes(item.specificStatus?.toLowerCase())
  : true;


   const search = this.searchText.toLowerCase();
const matchesSearch = this.searchText
  ? item.firstName?.toLowerCase().includes(this.searchText.toLowerCase()) ||
    item.lastName?.toLowerCase().includes(this.searchText.toLowerCase()) ||
    item.invoiceNumber?.toLowerCase().includes(this.searchText.toLowerCase()) ||
    item.companyName?.toLowerCase().includes(this.searchText.toLowerCase()) 
  : true;

    const matchesDate = this.filterDateSelection
      ? this.filterIsMonthRange
        ? (new Date(item.dueDate) >= new Date(this.filterDateSelection[0]) &&
           new Date(item.dueDate) <= new Date(this.filterDateSelection[1]))
        : (new Date(item.dueDate).getMonth() === new Date(this.filterDateSelection).getMonth() &&
           new Date(item.dueDate).getFullYear() === new Date(this.filterDateSelection).getFullYear())
      : true;

    return (
      matchesIgbmsId &&
      matchesAuthId &&
      matchesStatus &&
      matchesDate &&
      matchesSearch
    );
  });
  this.rerenderDataTable();

 
   setTimeout(() => {
    this.dtTrigger.next(null);
   }, 1000);

}


filteredData: any[] = [];
pagedData: any[] = [];


selectedHistory: any[] = [];
selectedItem: any;

viewHistory(item: any): void {
  this.selectedItem = item;
  this.selectedHistory = item.history || []; 
}



  ngOnInit(): void {

     this.dtOptions = {
      pagingType: 'simple_numbers',
      order: [],
       pageLength: 10,
      language: {
        searchPlaceholder: 'Search here...'
      },
      destroy: true,
    };
    this.getReceivables();
  }
  
    ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  

}
